import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../models/content.models';
import type {
  HomePageData,
  SiteAnnouncement,
  SiteSocialLinks,
  SuccessStoriesPageData,
  TestimonialsListingPageData,
} from '../models/marketing.models';

@Injectable({ providedIn: 'root' })
export class PagesService {
  constructor(private readonly api: ApiService) {}

  getMarketingHome() {
    return this.api.get<ApiEnvelope<HomePageData>>('public/marketing/home').pipe(map((r) => r.data));
  }

  getMarketingSuccessStories() {
    return this.api
      .get<ApiEnvelope<SuccessStoriesPageData>>('public/marketing/success-stories')
      .pipe(map((r) => r.data));
  }

  getMarketingTestimonialsListing() {
    return this.api
      .get<ApiEnvelope<TestimonialsListingPageData>>('public/marketing/testimonials')
      .pipe(map((r) => r.data));
  }

  getSiteAnnouncement() {
    return this.api
      .get<ApiEnvelope<SiteAnnouncement | undefined>>('public/marketing/announcement')
      .pipe(map((r) => r.data));
  }

  getSiteSocialLinks() {
    return this.api
      .get<ApiEnvelope<SiteSocialLinks | undefined>>('public/marketing/social-links')
      .pipe(map((r) => r.data));
  }

  getPlatformMarketingHome() {
    return this.api.get<ApiEnvelope<Record<string, unknown>>>(`platform/marketing/home`).pipe(map((r) => r.data));
  }

  patchPlatformMarketingHome(body: Record<string, unknown>) {
    return this.api.patch<ApiEnvelope<Record<string, unknown>>>(`platform/marketing/home`, body).pipe(map((r) => r.data));
  }
}
